import { DESTINATION_TYPES } from '../../../../destination/constants/destinationTypes';
import { TileGridCard } from '@hevoio/hevo-ui-toolkit';
import type { TileGridCardProps, TileGridCardBadgeConfig } from '@hevoio/hevo-ui-toolkit';
import { EntityTileProps } from '../../../../../layout/interfaces/tile';

const destinationTypes = DESTINATION_TYPES;

interface DestinationTileProps extends Pick<TileGridCardProps, 'selected' | 'faded' | 'selectedError' | 'subTextMaxLines'> {
  tile: EntityTileProps;
  isValidating?: boolean;
  validationError?: boolean;
  canUseEnterpriseNodeLogo?: boolean;
}

export function DestinationTile({
  tile,
  isValidating = false,
  validationError = false,
  selected,
  faded,
  selectedError,
  subTextMaxLines = 1,
}: DestinationTileProps) {
  const destinationType = destinationTypes[tile.data.dest_type];

  const badgeConfig: TileGridCardBadgeConfig = {
    new: { visible: !!destinationType?.showNewBadge && !tile.errored },
    draft: { visible: !!tile.data?.isDraft },
    edge: { visible: !!tile.metaData?.isEdge },
    failed: {
      visible: !!tile.errored,
      showTooltip: true,
      tooltipProps: {
        dataId: 'failed-badge-tooltip',
        title: tile.errorReason,
        placement: 'bottom',
      },
    },
  };

  return (
    <TileGridCard
      disabled={tile.disabled}
      error={tile.errored}
      selected={selected}
      faded={faded}
      selectedError={selectedError}
      logoURL={tile.thumbnail || ''}
      darkModeLogoURL={tile.darkModeThumbnail || ''}
      logoDataId='node-logo'
      title={tile.title}
      titleDataId={`${tile.data.id}-title`}
      subtitle={tile.data.dest_type_display || tile.data.destinationType?.displayName || ''}
      subtitleDataId={`${tile.data.id}-subtitle`}
      subTextMaxLines={subTextMaxLines}
      badgeConfig={badgeConfig}
      isValidating={isValidating}
      validationError={validationError}
    />
  );
}
